module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirts-2.0_OptionAll.85c126db.svg";